import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles, type Lang } from "@/mocks/articles";

function resolveLang(lang: string): Lang {
  return lang === "pl" || lang === "es" || lang === "fr" ? lang : "en";
}

export default function ArticleList() {
  const { t, i18n } = useTranslation();
  const lang = resolveLang(i18n.language);

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {articles.map((a) => (
        <Link
          key={a.slug}
          to={`/article/${a.slug}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
        >
          <div className="aspect-[16/10] w-full overflow-hidden bg-background-100">
            <img
              src={a.image}
              alt={a.title[lang]}
              title={`${t("site.name")} ${a.title[lang]}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col p-5">
            <span className="inline-flex w-fit items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              {a.category[lang]}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950">
              {a.title[lang]}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{a.short[lang]}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700">
              {t("articles.read")}
              <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}